import { useEffect } from "react";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { Modal } from "@circle-react-uikit/ModalV2";
import { PlansManagement } from "../../SettingsApp/Plan/PlanSettings/experiment/PlansManagement";
import { PlansProvider } from "../../SettingsApp/Plan/RegularPlan/PlansContext";

export const PlansModalBody = () => {
  const { trackEvent } = useEventsTracker();

  useEffect(() => {
    trackEvent("plan_settings.plans_modal.opened", {});
  }, [trackEvent]);

  return (
    <Modal.Body className="scrollbar-hide">
      <PlansProvider>
        <div className="mx-auto max-w-[1080px]">
          <PlansManagement />
        </div>
      </PlansProvider>
    </Modal.Body>
  );
};
